import React from 'react';

import AdvancedButton from '@portal/components/AdvancedButton/AdvancedButton';

import { getRouteStackPath } from '@portal/config/routes';
import useReduxState from '@portal/hooks/useReduxState';
import { translate } from '@portal/services/i18n';
import { moneyFormat } from '@portal/utils/format';
import { DateTime } from 'luxon';
import { useNavigation } from '@portal/hooks/useNavigation';

const PreApprovedLoans = () => {
  const navigate = useNavigation();

  const { preApprovedLoans } = useReduxState().loan;

  const handleSimulate = () => {
    navigate(getRouteStackPath('LOAN', 'SIMULATE'));
  };

  if (!preApprovedLoans || preApprovedLoans.length === 0) {
    return <></>;
  }

  return (
    <div className="pre-approved-loans">
      <p className="pre-approved-loans__title">
        {translate('PAGES.LOAN.PRE_APPROVED_LOANS.TITLE')}{' '}
        {moneyFormat(preApprovedLoans[0].maxAmount)}
      </p>
      <p className="pre-approved-loans__expiresAt">
        {translate('PAGES.LOAN.PRE_APPROVED_LOANS.EXPIRE_DATE')}{' '}
        {DateTime.fromISO(preApprovedLoans[0].expireDate).toFormat(
          translate('APPLICATION.DEFAULT_DATE_FORMAT.LUXON')
        )}
      </p>
      <div className="pre-approved-loans__button">
        <AdvancedButton
          text={translate('PAGES.LOAN.PRE_APPROVED_LOANS.SIMULATE')}
          onClick={handleSimulate}
        />
      </div>
    </div>
  );
};

export default PreApprovedLoans;
